export default () => {
  return {
    cookies: document.cookie,
    // Reuse the Optimizely/PDE userId the server already resolved for this request
    // (see entry.server.tsx hydration payload) so SSR and CSR bucket the same visitor
    // into the same experiment variant instead of each side computing its own id.
    hydratedUserId: window.__INITIAL_CONTEXT_VALUE__?.pdeUserId,
    isClient: true,
    pathName: window.location.pathname,
    userAgent: window.navigator.userAgent
  }
}
